import { Search } from 'lucide-react'
import type { FilterOptions } from '../types'
import { resultOptions, scoreOptions } from '../mockData'
import { FilterDropdown } from './FilterDropdown'

interface CallLogFiltersProps {
  filters: FilterOptions
  onFilterChange: (key: keyof FilterOptions, value: string) => void
  csrOptions: Array<{ value: string; label: string }>
}

export function CallLogFilters({ filters, onFilterChange, csrOptions }: CallLogFiltersProps) {
  return (
    <div className="flex items-center justify-between gap-4 mb-4">
      <div className="flex items-center gap-2">
        <h2 className="text-lg font-semibold text-gray-900 mr-4">CALL LOG</h2>

        {/* Result Filter */}
        <FilterDropdown
          label="Result"
          value={filters.result}
          options={resultOptions}
          onChange={(v) => onFilterChange('result', v)}
        />

        {/* CSR Filter */}
        <FilterDropdown
          label="CSR"
          value={filters.csr}
          options={csrOptions}
          onChange={(v) => onFilterChange('csr', v)}
        />

        {/* Score Filter */}
        <FilterDropdown
          label="Score"
          value={filters.scoreRange}
          options={scoreOptions}
          onChange={(v) => onFilterChange('scoreRange', v)}
        />
      </div>

      {/* Search Input */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          placeholder="Search name, phone, CSR..."
          value={filters.search}
          onChange={(e) => onFilterChange('search', e.target.value)}
          className="pl-9 pr-4 py-2 w-64 border border-gray-200 rounded-lg text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>
    </div>
  )
}
